import * as d3 from "d3";

export const measureTextHeight = (text, width, fontSize) => {
  const container = d3
    .select("body")
    .append("div")
    .attr("class", "temp-text-container")
    .style("font-size", fontSize)
    .style("width", `${width}px`)
    .style("position", "absolute")
    .style("visibility", "hidden")
    .style("white-space", "pre-wrap")
    .style("word-wrap", "break-word")
    .text(text);

  const height = container.node().getBoundingClientRect().height;
  container.remove();

  return height;
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }

  return text.substr(0, maxLength - 4) + "…";
};

export const wrapText = (text, maxLineCount, textBoxWidth) => {
  if (!text) return [];
  // if text not string
  if (typeof text !== "string") {
    text = text.toString();
  }
  const words = text.split(" ");
  const lines = [];
  if (words.length === 0) return lines;
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const newLine = currentLine + " " + word;

    if (lines.length < maxLineCount - 1) {
      if (newLine.length > textBoxWidth) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine = newLine;
      }
    } else {
      currentLine += word + " ";
    }
  }

  if (lines.length === maxLineCount - 1) {
    lines.push(truncateText(currentLine, textBoxWidth));
  } else {
    lines.push(currentLine);
  }
  return lines;
};

export const generateConstants = (isMobile, width, height) => {
  let maxDimension = 1300;
  let newWidth = width;
  let newHeight = height;

  // Add extra padding to height to prevent cutoff
  const verticalPadding = 200;
  newHeight = height + verticalPadding;

  let ratio = width / height;
  let fontSize = "1.0rem";

  let imgWidth = 240;
  let imgHeight = 240;

  if (newWidth > 900) {
    maxDimension = newWidth * 1.1;
  }

  if (ratio < 1) {
    newWidth = maxDimension * ratio;
    newHeight = maxDimension;
  } else {
    newWidth = maxDimension;
    newHeight = maxDimension / ratio;
  }

  let forceStrength = width < 650 ? 0.2 : 0.1;
  let forceX = d3.forceX(newWidth / 2).strength(forceStrength);
  let forceY = d3.forceY(newHeight / 2).strength(forceStrength);

  let textWidth = 200;

  if (width < 750) {
    fontSize = "1.5rem";
    textWidth = 350;
  }

  const centerX = newWidth / 2;
  const centerY = newHeight / 2;

  // if mobile width
  if (width < 650) {
    imgHeight = 300;
    imgWidth = 300;
    textWidth = 350;
    fontSize = "2rem";
    newHeight = height * 2.2;
    newWidth = width * 2;
  }

  let forceXVal = forceX;
  let forceYVal = forceY;

  width = newWidth;
  height = newHeight;
  return {
    width,
    height,
    forceXVal,
    forceYVal,
    fontSize,
    imgWidth,
    imgHeight,
    textWidth,
    centerX,
    centerY,
  };
};

export const opacityToColor = (opacity) => {
  const color = d3.interpolateRgb("white", "black")(opacity);
  return color;
};
